import store from '@/store';
import { jwtDecode } from 'jwt-decode';

const is_token_expired = (token) => {
    if (!token) {
        return true;
    }

    try {
        const { exp } = jwtDecode(token);
        const now = Math.floor(Date.now() / 1000);
        return exp < now;
    } catch (error) {
        console.log(error);
        return true;
    }
};

const is_valid_token = () => {
    if (!is_token_expired(store.getters.id_token)) {
        return true;
    }

    return false;
};

export { is_valid_token };